// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"aL-z","smallCardRow":"bL-z","largeCardRow":"cL-z","productSearchRow":"dL-z","curatedRow":"eL-z"};